<template>
  <div class="p-contact">

    <div class="s-header">
      <div class="s-header-copy">
        <div class="s-header-title">
          <ul class="f-xs">
            <li>Contact</li>
            <li>
              <a class="l-rg p-cta" target="_blank" follow="nofollow" href="https://statestreet-icx.efrontcloud.com/StateStreet">Investor Login</a>
            </li>
          </ul>
        </div>
        <div class="s-header-head">
          <h1 class="f-xl">
            <span class="f-xl-line">Locations.</span>
            <span class="f-xl-line">Contacts.</span>
            <span class="f-xl-line">Inquiries.</span>
          </h1>
        </div>
      </div>

      <div style="display: none;">
        <div class="s-header-scroll">
          <i class="s-header-indicator"></i>
          <p class="f-xs">Scroll &amp; Discover</p>
        </div>
      </div>

      <div class="s-header-image">
        <div class="s-header-src"></div>
      </div>

      <div class="scroll-down">
        <div class="scroll-down-arrow" @click="emitEventScroll"></div>
      </div>
    </div>

    <Contact />


      <div class="s-text">
        <div class="s-text-wrap">
          <p class="f-md" data-animate="fade">
            To request additional information regarding VR, please provide the information requested below and submit.
          </p>
          <p class="f-md" data-animate="fade">
            A member of our team will be in
            contact as soon as possible.
          </p>
          <p class="f-md" data-animate="fade">
            Contact details are for internal use
            only and will not be shared with third
            parties.
          </p>
        </div>
      </div>

      <Form />


    <Footer />
  </div>
</template>

<script>
import { gsap } from 'gsap';
import Sniffer from 'sniffer';
import Contact from '@/components/contact/contact.vue';
import Form from '@/components/form/request.vue';
import Footer from '@/components/footer/footer.vue';

export default {
  components: {
    Contact,
    Form,
    Footer,
  },

  methods: {
    emitEventScroll() {
      const scrollToEvent = new CustomEvent('customScrollTo', {
        detail: { scrollVal: window.innerHeight },
      });
      if (Sniffer.isPhone) gsap.to('.a-scroll', { duration: 1, scrollTo: window.innerHeight });

      window.dispatchEvent(scrollToEvent);
    },
  },
};
</script>
